<template>
  <div class="mt-2">
    <div class="table-responsive-sm table-responsive-md">
      <table class="table table-striped table-hover table-bordered table-sm">
        <thead>
          <tr style="text-align: center">
            <th scope="col">No</th>
            <th scope="col">Gambar</th>
            <th scope="col">Barcode</th>
            <th scope="col">Internal</th>
            <th scope="col">Deskripsi</th>
            <th scope="col">Nama File</th>
            <th scope="col">Tgl Buat</th>
            <th scope="col">Status</th>
            <th scope="col">
              <span v-if="!statusCheckedImage">Aksi</span
              ><input
                v-if="statusCheckedImage"
                style="width: 20px !important; height: 20px !important"
                type="checkbox"
                id="flexCheckDefault2"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(n, i) in datas" :key="i" style="cursor: pointer">
            <td style="text-align: center">{{ i + 1 }}</td>
            <td style="text-align: center" @click="setPreview(n)">
              <img
                :src="
                  n.imageurl ? n.imageurl : '../../assets/image/noimage.png'
                "
                alt="Image Preview"
                class="img img-fluid"
                loading="lazy"
                style="width: 60px; height: 60px"
              />
            </td>
            <td style="text-align: center">
              {{ n.originalname ? n.originalname : '-' }}
            </td>
            <td style="text-align: center">{{ n.internal ? n.internal : '-' }}</td>
            <td>{{ n.date_rejected ? n.desc_rejected : n.descript }}</td>
            <td style="text-align: center">
              {{ n.filename ? n.filename : '-' }}
            </td>
            <td style="text-align: center">{{ n.date_rejected ? n.date_rejected : n.dcreated }}</td>
            <td style="text-align: center">
              <span
                v-if="n.status === '1'"
                class="badge rounded-pill text-bg-warning ps-2 pe-2 pt-1 pb-1"
                >Waiting</span
              >
              <span
                v-if="n.status === '2'"
                class="badge rounded-pill text-bg-success ps-2 pe-2 pt-1 pb-1"
                >Approved</span
              >
              <span
                v-if="n.status === '3'"
                class="badge rounded-pill text-bg-danger ps-2 pe-2 pt-1 pb-1"
                >Rejected</span
              >
            </td>
            <td class="text-center">
              <button
                class="btn btn-danger btn-sm"
                v-if="!statusCheckedImage && n.status === '1'"
                data-bs-toggle="modal"
                data-bs-target="#deleteModal"
                @click="setDeleted(n)"
              >
                <i class="fas fa-trash"></i>
              </button>
              <input
                v-if="statusCheckedImage && n.status === '1'"
                style="width: 20px !important; height: 20px !important"
                type="checkbox"
                :value="n"
                v-model="tempImages"
                id="flexCheckDefault"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <DeleteModalComponent
      :data="data"
      @saveDelete="deleteImage"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteModalComponent from "@/components/DeleteModalComponent.vue";

export default {
  name: "GaleryImageProductComponent",
  data() {
    return {
      data: {},
    };
  },
  components: {
    DeleteModalComponent,
  },
  computed: {
    ...mapState({
      datas: (state) => state.ImageProduct.datas,
      statusCheckedImage: (state) => state.ImageProduct.statusCheckedImage,
    }),
    tempImages: {
      get() {
        return this.$store.state.ImageProduct.tempCheckedImages;
      },
      set(value) {
        this.$store.commit("ImageProduct/SET_TEMP_CHECKED_IMAGE", value);
      },
    },
  },
  methods: {
    ...mapActions({
      deleteImage: "ImageProduct/delete",
    }),
    setDeleted(value) {
      this.data = value;
    },
    setPreview(data) {
      this.$store.commit("ImageProduct/SET_DATA_PREVIEW", data);
      this.$store.commit("ImageProduct/SET_PREVIEW");
    },
  },
};
</script>
